import { z } from 'zod/v4';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
const inputSchema = z.object({
    summary: z
        .string()
        .min(1)
        .max(2000)
        .describe('The concrete action or decision that needs human attention, including the relevant context already found.'),
});
const outputSchema = z.object({
    acknowledged: z.literal(true),
});
export const escalateToHumanTool = {
    name: ToolName.EscalateToHuman,
    category: ToolCategory.Meta,
    weight: ToolWeight.Terminal,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Escalate a concrete action or decision to a human and end the run. Use this only when human attention is required and no safe HEAVY tool can perform the needed action. The summary becomes a dismissible agent notice. Calling this terminates the run.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=escalate-to-human.js.map